import React from 'react'
import FilterCard from 'components/FilterCard/startСomponent/FilterCard'
import { useFilterCardLocal } from 'components/FilterCard/hooks/useFilterCardLocal'

const FilterCardLocal = ({ data = [], label, allItemsLabel, height, labelStyles, onChange, withSearch }) => {
	const { methods,
		showModal,
		setShowModal,
		handleClick,
		handleAllActiveClick,
		handleSave,
		columns
	} = useFilterCardLocal(data, onChange)
	return <FilterCard data={data} methods={methods} allItemsLabel={allItemsLabel} height={height} label={label} showModal={showModal} setShowModal={setShowModal} labelStyles={labelStyles} handleClick={handleClick} handleAllActiveClick={handleAllActiveClick} handleSave={handleSave} columns={columns} withSearch={withSearch} />
}

export default FilterCardLocal
